import type { ApiListingApplicationListingType } from '#/api/types/ApiListingApplicationListingType';
import type { ApiOrgId } from '#/api/types/ApiTypedId';
import { ApiOrgType } from '#/modules/listing/orgs/api/types/ApiOrgType';
import { trackEvent } from '#/utils/analytics/track/trackEvent';

type Args = {
  listingType: ApiListingApplicationListingType;
  listingId: string;
  orgId: ApiOrgId | null;
  orgType: ApiOrgType | null;
  applied: boolean;
};

export function trackViewListingAtsSection({
  listingType,
  listingId,
  orgId,
  orgType,
  applied,
}: Args) {
  trackEvent('Section View: Idealist ATS', {
    listing_type: listingType,
    listing_id: listingId,
    org_id: orgId ?? null,
    org_type: orgType ?? null,
    has_applied: applied,
  });
}
